import { render, staticRenderFns } from "./Kaali.vue?vue&type=template&id=7b06c65b&scoped=true"
import script from "./Kaali.vue?vue&type=script&lang=js"
export * from "./Kaali.vue?vue&type=script&lang=js"
import style0 from "./Kaali.vue?vue&type=style&index=0&id=7b06c65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06c65b",
  null
  
)

export default component.exports